import type { ScriptEntryStatus } from '@luacentrix/contracts';

export const SCRIPT_COLLECTION_PATH = '/api/v1/scripts';

export const SCRIPT_LOADER_PATH = `${SCRIPT_COLLECTION_PATH}/loader`;

export const SCRIPT_OBFUSCATE_PATH = `${SCRIPT_COLLECTION_PATH}/obfuscate`;

export const PUBLIC_OBFUSCATE_PATH = '/api/v1/public/obfuscate';

export function scriptItemPath(scriptId: string): string {
  return `${SCRIPT_COLLECTION_PATH}/${encodeURIComponent(scriptId)}`;
}

export function scriptPlacesPath(scriptId: string): string {
  return `${scriptItemPath(scriptId)}/places`;
}

export interface ScriptListQuery {
  limit?: number | undefined;
  cursor?: string | undefined;
  status?: ScriptEntryStatus | undefined;
  search?: string | undefined;
}

export function scriptListQueryValues(query: ScriptListQuery = {}): Record<string, string> {
  const values: Record<string, string> = {};
  if (query.limit !== undefined && query.limit > 0) {
    values.limit = String(query.limit);
  }
  if (query.cursor !== undefined && query.cursor !== '') {
    values.cursor = query.cursor;
  }
  if (query.status !== undefined) {
    values.status = query.status;
  }
  if (query.search !== undefined && query.search !== '') {
    values.search = query.search;
  }
  return values;
}
